import styled from 'styled-components/macro';
import palette from 'palette';

export const StyledDevTitle = styled.span`
  color: ${palette.blue.b1};
`;
